export default __webpack_public_path__ + "static/media/dg9.ebcc5794.jpg";